import React from 'react';
// components
import BaseSelect from 'src/shared/components/inputs/BaseSelect';

const FixedValueSelectEnum = ({ fixedValueProps, name, value, setFieldValue, defaultItem, readOnly }) => {
  const { fixedValues } = fixedValueProps;

  const fieldMapper = (fieldValue) => {
    if (!fieldValue) {
      return null;
    }

    const { description, value } = fieldValue;
    return {
      value,
      label: description,
    };
  };

  let defaultValue = {};

  if (defaultItem) {
    const foundItem = fixedValues?.find((x) => x.value === parseInt(defaultItem));
    if (foundItem) {
      defaultValue = fieldMapper(foundItem);
    }
  }

  return (
    <BaseSelect
      onChange={({ value }) => setFieldValue(value?.value)}
      label=''
      textField='label'
      data={fixedValues?.map(fieldMapper)}
      name={name}
      value={fieldMapper(fixedValues?.find((v) => v.value === parseInt(value)))}
      isCombo
      defaultItem={defaultValue}
      readOnly={readOnly}
    />
  );
};

export default FixedValueSelectEnum;
